import { render, staticRenderFns } from "./queue-table.vue?vue&type=template&id=66cc3377&scoped=true&"
import script from "./queue-table.vue?vue&type=script&lang=ts&"
export * from "./queue-table.vue?vue&type=script&lang=ts&"
import style0 from "./queue-table.vue?vue&type=style&index=0&id=66cc3377&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cc3377",
  null
  
)

export default component.exports